import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

interface LogoProps {
  className?: string;
  textColor?: string;
}

export function Logo({ 
  className = '', 
  textColor = 'text-white'
}: LogoProps) {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.2 }}
    >
      <Link to="/" className={cn('inline-flex flex-col group', className)}>
        <div className="flex items-center">
          <motion.span 
            className="text-3xl font-bold text-emerald-300 ml-4 group-hover:text-emerald-200 transition-colors"
            whileHover={{ rotate: [0, -10, 10, 0] }}
            transition={{ duration: 0.5 }}
          >
            ₦
          </motion.span>
          <span className={`text-2xl font-bold ${textColor} ml-0.5 group-hover:text-emerald-100 transition-colors`}>
            igeria
          </span>
          <span className={`text-xl font-bold ${textColor} group-hover:text-emerald-100 transition-colors`}>
            Fx
          </span>
        </div>
        <span className="text-xs text-emerald-200 ml-4 group-hover:text-emerald-100 transition-colors">
          Live Exchange Rates & Market Analysis
        </span>
      </Link>
    </motion.div>
  );
}